module.exports = __webpack_public_path__ + "img/error-n.b2762a09.svg";